import { render, staticRenderFns } from "./Gurubets.vue?vue&type=template&id=ab57c1fc&scoped=true"
import script from "./Gurubets.vue?vue&type=script&lang=js"
export * from "./Gurubets.vue?vue&type=script&lang=js"
import style0 from "./Gurubets.vue?vue&type=style&index=0&id=ab57c1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab57c1fc",
  null
  
)

export default component.exports